import api from './axiosInstance';
import { Vehiculo} from 'src/models/types';

export const getVehiculos = async (): Promise<Vehiculo[]> => {
  const resp = await api.get("/vehiculos");
  return resp.data.dataResult; // extraemos el array directamente
};

export const getVehiculosAsignados = async (): Promise<Vehiculo[]> => {
  const resp = await api.get("/vehiculos/asignados");
  return resp.data.dataResult; // extraemos el array directamente
};

export const saveVehiculo = async (vehiculo: Vehiculo) => {
  if (vehiculo.id === 0) {
    return api.post('/vincularVehiculo', vehiculo);
  } else {
    return api.put(`/vincularVehiculo/${vehiculo.id}`, vehiculo);
  }
};


export const updateVehiculo = async (vehiculo: Vehiculo) => {
  try {
    console.log("Enviando vehiculo vs:", JSON.stringify(vehiculo, null, 2));
    const response = await api.post("/vincularVehiculo", vehiculo);
    return response.data; // devuelve lo que el backend retorne
  } catch (error) {
    console.error("Error al actualizar vehículo vs:", error);
    throw error; // importante para que handleGuardar lo capture
  }
};